import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import error from '../../../../../assets/toastIcons/error-icon.png';
import styles from './index.less';

let timer: NodeJS.Timeout | null = null;

export default class Toast extends React.Component {
  /**
   * 显示错误提示
   * @param mes - 提示消息
   * @param place - 显示位置 ('top' | 'bottom' | 'center')
   * @param duration - 显示时长（毫秒）
   */
  static error(mes: string = 'fail', place: string = 'bottom', duration: number = 2500) {
    init();
    setTime(duration);
    const boxStyle = getBoxPlace(place);
    
    ReactDOM.render(
      <Fragment>
        <div className={styles['toast']}>
          <div className={styles['toast-box']} style={boxStyle}>
            <img className={styles['toast-icon']} src={error} alt="" />
            <span className={styles['toast-text']}>{mes}</span>
          </div>
        </div>
      </Fragment>,
      document.getElementById('toast')
    );
  }
}

/**
 * 根据位置参数返回对应的样式
 */
function getBoxPlace(place: string): React.CSSProperties {
  let boxStyle: React.CSSProperties = {};
  
  switch (place) {
    case 'top':
      boxStyle = { top: '120px', transform: 'translateX(-50%)' };
      break;
    case 'bottom':
      boxStyle = { bottom: '84px', transform: 'translateX(-50%)' };
      break;
    case 'center':
      boxStyle = { 
        top: '50%', 
        transform: 'translate(-50%, -50%)' 
      };
      break;
    default:
      boxStyle = { transform: 'translateX(-50%)' };
      break;
  }
  
  return boxStyle;
}

/**
 * 初始化toast容器
 */
function init() {
  if (timer) {
    clearTimeout(timer);
  }
  
  let toast = document.getElementById('toast');
  
  if (toast) {
    toast.style.display = 'block';
  } else {
    const div = document.createElement('div');
    div.setAttribute('id', 'toast');
    document.body.appendChild(div);
  }
}

/**
 * 设置自动隐藏定时器
 */
function setTime(duration: number) {
  timer = setTimeout(() => {
    const toast = document.getElementById('toast');
    if (toast) {
      toast.style.display = 'none';
    }
  }, duration);
}
